import axios from "axios";
import { isArray, isEmpty, isNil } from "lodash";
import { useCallback } from "react";

import { useAxiosHook } from "./useAxiosHook";

const ROUTE_PREFIX = "borrower_portal";
let IS_TESTING = true;
IS_TESTING = false;

export const useBorrowerPortalHook = () => {
  const {
    axiosPostIsLoading,
    isLoading,
    axiosGetIsLoading,
    axiosError,
    axiosGetRequest,
    axiosPostRequest,
  } = useAxiosHook();

  const loading = isLoading || axiosGetIsLoading || axiosPostIsLoading;
  const borrowerPortalHookLoading = loading;
  const error = axiosError;

  const assignBorrowerFileToLoan = useCallback(
    async ({
      loanId,
      file_storage_name,
      isFile = true,
      fileDownloadName,
      onSuccessFn,
      fileDownload,
      openInNewTab,
      onFailFn,
    }) => {
      if (!file_storage_name || !loanId) {
        console.error("Missing loanId or file_storage_name");
        // setError("Missing loanId or file_storage_name");
        // setLoading(false);
        return;
      }
      // const endpoint = `${ROUTE_PREFIX}/file_by_id/${loanId}/${file_storage_name}`;
      const endpoint = `${ROUTE_PREFIX}/assign_borrower_doc_to_loan/${file_storage_name}/${loanId}`;
      const source = axios.CancelToken.source();
      const params = {
        name: "Assign Borrower File To Loan",
        path: endpoint,
        cancelSource: source,
        isFile,
        fileDownloadName,
        fileDownload,
        openInNewTab,
        onSuccessFn,
        onFailFn,
      };
      await axiosPostRequest(params);
    },
    [axiosPostRequest],
  );

  /**
   * ---------------------------------------------------------------
   * ---------------------------------------------------------------
   * TRIED BUT WAITING TO BE FIXED
   * ---------------------------------------------------------------
   * ---------------------------------------------------------------
   */
  const updateBorrowerDocMetaData = async ({
    data,
    onSuccessFn,
    onCompleteFn,
    onSuccessMsg,
    onFailFn,
  }) => {
    if (isEmpty(data) || !isArray(data)) {
      console.error("Profile update data is missing", { data });
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/update_borrower_doc_metadata`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Update Borrower Document Meta Data",
      payload: data,
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onSuccessMsg,
      onFailMsg: "Could not update profile",
      onFailFn,
    });
  };

  /**
   * ---------------------------------------------------------------
   * ---------------------------------------------------------------
   * CONFIRMED WORKING
   * ---------------------------------------------------------------
   * ---------------------------------------------------------------
   */

  /**
   * -------------------------------------
   *  SIGN UP
   * -------------------------------------
   */

  const signUpBorrower = async ({
    data,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    if (isEmpty(data)) {
      console.error("Borrower data is missing", { data });
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/sign_up`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Sign Up Borrower",
      payload: data,
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      includeQueryParams: true,
      onFailFn,
    });
  };

  const signUpBorrowerHandsomeHomebuyer = async ({
    data,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    if (isEmpty(data)) {
      console.error("Borrower data is missing", { data });
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/handsome_homebuyer/sign_up`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Sign Up Borrower",
      payload: data,
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      includeQueryParams: true,
      onFailFn,
    });
  };

  /**
   * -------------------------------------
   *  CREATING
   * -------------------------------------
   */
  const createNewApplicationDeal = async ({
    data,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    if (isEmpty(data)) {
      console.error("Loan application data is missing", { data });
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/new_application_deal_no_files`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Create Financing Request Without Files",
      payload: data,
      path: endpoint,
      // formData: true,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };
  const createNewApplicationDealWithFiles = async ({
    data,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    if (isEmpty(data)) {
      console.error("Loan application data is missing", { data });
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/new_application_deal`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Create Financing Request With Files",
      payload: data,
      path: endpoint,
      formData: true,
      // errorTesting: true,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });

    //     await axiosPostRequest({
    //   name: "Create Loan With File Uploads",
    //   path: endpoint,
    //   formData: true,
    //   payload: data,
    //   cancelSource: source,
    //   onSuccessFn,
    //   // errorTesting: true,
    //   onCompleteFn,
    //   onFailFn,
    // });
  };

  const createCreditAuth = async ({
    data,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    if (isEmpty(data)) {
      console.error("Credit authorization data is missing", { data });
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/new_credit_auth`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Create Credit Authorization",
      path: endpoint,
      payload: data,
      formData: true,
      includeQueryParams: true,
      onSuccessMsg: "Credit Authorization Submitted Successfully",
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const uploadBorrowerDocuments = async ({
    files,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    if (isEmpty(files)) {
      console.error("Document upload files are missing", { files });
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/upload_borrower_docs`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Upload Documents",
      path: endpoint,
      files: files,
      formData: true, // For file uploads
      // payload: data,
      // errorTesting: true, // For testing purposes
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const uploadBorrowerIdDocument = async ({
    data,
    files,
    onSuccessFn,
    onCompleteFn,
    hideSuccessMsg,
    onFailFn,
  }) => {
    if (isEmpty(files)) {
      console.error("Borrower ID upload files is missing", { files });
      return;
    }
    // if (isEmpty(data)) {
    //   console.error("Borrower ID upload files is missing", { data });
    //   return;
    // }

    const endpoint = `${ROUTE_PREFIX}/borrower_upload_id_document`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Upload Borrower ID with Document Intelligence",
      files: files,
      formData: true,
      // payload: data,
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
      onSuccessMsg: hideSuccessMsg ? null : "ID Document Uploaded Successfully",
      // onSuccessMsg: hideSuccessMsg
      //   ? null
      //   : "Borrower ID Document Uploaded Successfully",
      // errorTesting: true, // For testing purposes
    });

    /**
     * RES
   {
    "_id": "68656b1f71baedded8c361bf",
    "isHidden": null,
    "isFinal": false,
    "containerName": "68624bd32be3cdb8592f6dc7",
    "docGroup": "Borrower Documents",
    "docType": "Photo Identification",
    "file_name_as_loaded": "driver-lisc-front.jpg",
    "file_display_name": "driver-lisc-front.jpg",
    "file_storage_name": "4da9b00a-5769-11f0-bd9b-aeaca802f011.jpg",
    "content_type": "image/jpeg",
    "size": 1418217,
    "uploadedBy": "joliva@cliffcomortgage.com",
    "uploadDate": "2025-07-02T16:54:56.642599",
    "modifiedDate": "2025-07-02T16:54:56.642620",
    "unique_id": null,
    "dealId": null,
    "name": "driver-lisc-front.jpg",
    "file_extension": "jpg"
}
     */
  };

  /**
   * -------------------------------------
   *  FETCHING
   * -------------------------------------
   */
  const getBorrowerProfile = async ({
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    if (IS_TESTING) {
      // onSuccessFn(REQUEST_DATA_getBorrowerProfile);
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/get_borrower_profile`;
    const source = axios.CancelToken.source();

    await axiosGetRequest({
      name: "Get Borrower Profile",
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const getApplicationLoans = async ({
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    // onSuccessFn(useBorrowerPortalHookDummyData.getApplications);
    // return;
    // onSuccessFn(REQUEST_DATA_getLoanApplication);
    // if (IS_TESTING) {
    //   onSuccessFn(REQUEST_DATA_getApplications);
    //   return;
    // }

    // onSuccessFn(REQUEST_DATA_getApplications);
    // return;
    const endpoint = `${ROUTE_PREFIX}/my_applications`;
    const source = axios.CancelToken.source();

    await axiosGetRequest({
      name: "Get Loan Applications",
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const getBorrowerCreditAuths = async ({
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    return;

    const endpoint = `${ROUTE_PREFIX}/my_credit_auths`;
    const source = axios.CancelToken.source();

    await axiosGetRequest({
      name: "Get Credit Authorizations",
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const getRegisteredUsers = async ({
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    if (IS_TESTING) {
      console.warn("TESTING MODE");
      return;
    }
    // onSuccessFn(
    //   useBorrowerPortalHookDummyData.getRegisteredUsersHandsomeHomebuyer
    // );
    return;
    const endpoint = `${ROUTE_PREFIX}/signed_up_users/all`;
    const source = axios.CancelToken.source();

    await axiosGetRequest({
      name: "Get Signed Up Users",
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const getRegisteredUsersHandsomeHomebuyer = async ({
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    if (IS_TESTING) {
      console.warn("TESTING MODE");
      return;
    }
    // onSuccessFn(
    //   useBorrowerPortalHookDummyData.getRegisteredUsersHandsomeHomebuyer
    // );
    return;

    const endpoint = `${ROUTE_PREFIX}/signed_up_users/handsome_homebuyer`;
    const source = axios.CancelToken.source();

    await axiosGetRequest({
      name: "Get Signed Up Users",
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const getApplicationLoanById = async ({
    id,
    onSuccessFn,
    onCompleteFn,
    onFailFn,
  }) => {
    // onSuccessFn(useBorrowerPortalHookDummyData.getApplicationLoanById);
    // return;
    if (isNil(id)) {
      console.error("Loan ID is missing", { id });
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/application/${id}`;
    const source = axios.CancelToken.source();

    await axiosGetRequest({
      name: "Get Application",
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailFn,
    });
  };

  const getBorrowerFileById = useCallback(
    async ({
      file_storage_name,
      isFile = true,
      fileDownloadName,
      onSuccessFn,
      fileDownload,
      openInNewTab,
      onFailFn,
    }) => {
      if (!file_storage_name) {
        console.error("Missing loanId or file_storage_name");
        // setError("Missing loanId or file_storage_name");
        // setLoading(false);
        return;
      }
      // const endpoint = `${ROUTE_PREFIX}/file_by_id/${loanId}/${file_storage_name}`;
      const endpoint = `${ROUTE_PREFIX}/borrower_file_by_id/${file_storage_name}`;
      const source = axios.CancelToken.source();
      const params = {
        name: "Get Borrower File By Id",
        path: endpoint,
        cancelSource: source,
        isFile,
        fileDownloadName,
        fileDownload,
        openInNewTab,
        onSuccessFn,
        onFailFn,
      };
      await axiosGetRequest(params);
    },
    [axiosGetRequest],
  );

  const getBorrowerLoanFileById = useCallback(
    async ({
      loanId,
      file_storage_name,
      isFile = true,
      fileDownloadName,
      onSuccessFn,
      fileDownload,
      openInNewTab,
      onFailFn,
    }) => {
      if (!file_storage_name || !loanId) {
        console.error("Missing loanId or file_storage_name");

        return;
      }

      const endpoint = `${ROUTE_PREFIX}/borrower_loan_file_by_id/${loanId}/${file_storage_name}`;
      const source = axios.CancelToken.source();
      const params = {
        name: "Get Borrower Loan File By Id",
        path: endpoint,
        cancelSource: source,
        isFile,
        fileDownloadName,
        fileDownload,
        openInNewTab,
        onSuccessFn,
        onFailFn,
      };
      await axiosGetRequest(params);
    },
    [axiosGetRequest],
  );

  /**
   * -------------------------------------
   *  UPDATING
   * -------------------------------------
   */
  const updateBorrowerProfile = async ({
    data,
    onSuccessFn,
    onCompleteFn,
    onSuccessMsg = "Profile updated successfully",
    onFailFn,
  }) => {
    if (isEmpty(data)) {
      console.error("Profile update data is missing", { data });
      return;
    }

    const endpoint = `${ROUTE_PREFIX}/update_borrower_profile`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Update Borrower Profile",
      payload: data,
      path: endpoint,
      cancelSource: source,
      onSuccessFn,
      onCompleteFn,
      onFailMsg: "Could not update profile",
      onSuccessMsg,
      onFailFn,
    });
  };

  return {
    loading,
    borrowerPortalHookLoading,
    error,
    signUpBorrower,
    signUpBorrowerHandsomeHomebuyer,
    getBorrowerProfile,
    // getBorrowerDocuments,
    createCreditAuth,
    createNewApplicationDeal,
    createNewApplicationDealWithFiles,
    getBorrowerCreditAuths,
    getApplicationLoans,
    updateBorrowerProfile,
    uploadBorrowerDocuments,
    uploadBorrowerIdDocument,
    getRegisteredUsers, // admin
    getRegisteredUsersHandsomeHomebuyer, // admin
    getApplicationLoanById,
    getBorrowerFileById,
    getBorrowerLoanFileById,
    updateBorrowerDocMetaData,
    assignBorrowerFileToLoan,
  };
};
